import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import "./css/AddHighlight.css";

export default function AddHighlight() {
  const navigate = useNavigate();
  const [marketList, setMarketList] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    number: "",
    date: format(new Date(), "yyyy-MM-dd"),
    market: "",
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/get_markets.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.markets) {
          setMarketList(data.markets);
        }
      });
  }, []);

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitHighlight = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");

    try {
      const paddedNumber = formData.number.padStart(2, "0");

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/add_highlighted.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, number: paddedNumber }),
      });

      const result = await response.json();
      setMessage(result.message);

      if (result.success) {
        setFormData({
          number: "",
          date: format(new Date(), "yyyy-MM-dd"),
          market: "",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const isSuccess = message.toLowerCase().includes("success") || message.toLowerCase().includes("added");

  return (
    <div className="ah-page">
      <div className="ah-topbar">
        <button className="ah-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <div className="ah-title">Add Highlighted Number</div>
      </div>

      <div className="ah-content">
        <div className="ah-card">
          <div className="ah-icon-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9-6.3 3.9 1.7-7L2 9.2l7.1-.6z" />
            </svg>
          </div>
          <div className="ah-card-title">Highlight a Number</div>
          <div className="ah-card-subtitle">Mark a number as low-load for a market &amp; date</div>

          <form onSubmit={submitHighlight}>
            <div className="ah-field">
              <label className="ah-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="3" />
                  <path d="M9 9h.01M15 9h.01M9 15h6" />
                </svg>
                Number (00–99)
              </label>
              <input
                type="number"
                name="number"
                value={formData.number}
                onChange={handleChange}
                min="0"
                max="99"
                placeholder="e.g. 5"
                required
              />
              <div className="ah-hint">Single digits are auto-padded, e.g. 5 → 05</div>
            </div>

            <div className="ah-field">
              <label className="ah-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="3" />
                  <path d="M16 2v4M8 2v4M3 10h18" />
                </svg>
                Date
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ah-field">
              <label className="ah-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18" />
                  <path d="M7 15l4-5 3 3 5-7" />
                </svg>
                Market
              </label>
              <select
                name="market"
                value={formData.market}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Market --</option>
                {marketList.map((market, index) => (
                  <option key={index} value={market}>
                    {market.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>

            <button type="submit" className="ah-submit" disabled={submitting}>
              {submitting ? "Adding…" : "Add Highlight"}
            </button>
          </form>

          {message && (
            <div className={`ah-message ${isSuccess ? "success" : ""}`}>{message}</div>
          )}
        </div>
      </div>
    </div>
  );
}
